import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";

export function useSignupMutation() {
  return useMutation({ mutationFn: authApi.signup });
}
